import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';

export default function HeroSection() {
  return (
    <section
      className="relative min-h-[90vh] flex items-center overflow-hidden"
      data-testid="hero-section"
      style={{
        backgroundImage: `url(https://static.prod-images.emergentagent.com/jobs/f0f5f9d2-54c2-4e20-9504-6a4092245c91/images/c8c629e600445778e9c5ca295e0ccd85bb89f5ea0386f57ada57c7e7aaa7fb16.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B132B]/95 via-[#0B132B]/80 to-[#0B132B]/50" />

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 xl:px-24 py-32">
        <div className="max-w-3xl mx-auto text-center">
          {/* Label */}
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#10B981]/40 text-[#10B981] text-xs tracking-[0.2em] uppercase font-bold mb-8">
            <span className="w-1.5 h-1.5 bg-[#10B981] rounded-full animate-pulse" />
            Enterprise Cloud Solutions
          </div>

          {/* Headline */}
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black text-white leading-[1.05] mb-6"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            Next-Generation IT, Agentic AI, and Cloud Infrastructure<span className="text-[#0052FF]">.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-10 max-w-2xl mx-auto" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            Empowering global enterprises with scalable DevOps, automated QA,
            and intelligent cost optimization.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="#service-catalog"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#0052FF] text-white text-base font-bold tracking-wide hover:bg-[#0040CC] transition-colors duration-200"
              data-testid="hero-explore-btn"
            >
              Explore Our Solutions
              <ArrowRight size={18} weight="bold" />
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 border border-white/30 text-white text-base font-bold tracking-wide hover:bg-white/10 transition-colors duration-200"
              data-testid="hero-consult-btn"
            >
              Consult a Solutions Architect
            </Link>
          </div>

          {/* Stats strip */}
          <div className="flex flex-wrap justify-center gap-12 mt-16 pt-8 border-t border-white/10">
            {[
              { value: '99.99%', label: 'Uptime SLA' },
              { value: '2', label: 'Global Regions' },
              { value: '24/7', label: 'Enterprise Support' },
            ].map((stat) => (
              <div key={stat.label}>
              <div className="text-3xl font-black text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>{stat.value}</div>
              <div className="text-sm tracking-[0.15em] uppercase text-slate-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
